import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Company } from '../interfaces/company.interface';

export interface CompanyDto {
	id: number;
	creationDate: string;
	name: string;
	fullIdentifier: string;
	companyType: CompanyType;
	externalReference: string;
	timezoneString: string;
	dateFormat: string;
	isMainCompany: boolean;
	parentCompanyId?: number | null;
	initOwnerEmail: string;
}

export interface CompanyCreateDto {
	name: string;
	fullIdentifier: string;
	externalReference: string;
	companyType: CompanyType;
	parentCompanyId?: number | null;
	isMainCompany: boolean;
	initOwnerEmail: string;
}

export interface CompanyUpdateDto {
	id: number;
	name: string;
	timezoneString: string;
	dateFormat: string;
	isMainCompany: boolean;
	parentCompanyId?: number | null;
	initOwnerEmail: string;
}

export interface UserDto {
	id: number;
	username: string;
	firstName: string;
	lastName: string;
	email: string;
}

export interface UserCompanyView {
	id: number;
	companyId: number;
	companyName: string;
	userId: number;
	userName: string;
	isOwner: boolean;
}

// TODO: Could be specific.
type CompanyType = number;

@Injectable({
	providedIn: 'root'
})
export class AlCompanyV2Service {
	url: string = 'v2/companies';

	constructor(private http: HttpClient) {}

	// CRUD start
	public getAll(): Observable<CompanyDto[]> {
		return this.http.get<CompanyDto[]>(`${this.url}`);
	}

	public get(companyId: number): Observable<CompanyDto> {
		return this.http.get<CompanyDto>(`${this.url}/${companyId}`);
	}

	public post(company: CompanyCreateDto): Observable<CompanyDto> {
		return this.http.post<CompanyDto>(`${this.url}`, company);
	}

	public put(company: CompanyUpdateDto): Observable<CompanyDto> {
		return this.http.put<CompanyDto>(`${this.url}/${company.id}`, company);
	}

	public delete(companyId: number): Observable<CompanyDto> {
		return this.http.delete<CompanyDto>(`${this.url}/${companyId}`);
	}
	// CRUD end

	public getAllPotentialParentCompanies(): Observable<CompanyDto[]> {
		return this.http.get<CompanyDto[]>(`${this.url}/potentialParentCompanies`);
	}
}
